<template>
  <div>
    <Paginate
      :page-count="pageCount"
      :page-range="pageRange"
      :margin-pages="1"
      prev-text="Previous"
      next-text="Next"
      :model-value="modelValue"
      :first-last-button="false"
      :container-class="$style.containerClass"
      :page-class="$style.pageClass"
      :page-link-class="$style.pageLinkClass"
      :prev-link-class="$style.prevLinkClass"
      :next-link-class="$style.nextLinkClass"
      :active-class="$style.activeClass"
      :disabled-class="$style.disabledClass"
      @update:modelValue="click"
    />
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import Paginate from './Paginate.vue';

export default defineComponent({
  components: { Paginate },
  props: {
    pageRange: { type: Number, default: 6 },
    pageCount: { type: Number, required: true },
    modelValue: { type: Number, required: true },
  },
  methods: {
    click(e) {
      this.$emit('update:modelValue', e);
    },
  },
});
</script>

<style lang="scss" module>
.containerClass {
  opacity: 1;
  list-style: none;
  display: flex;
  align-items: center;
  user-select: none;
  flex-wrap: wrap;
  
  a {
    cursor: pointer;
  }
}
.pageLinkClass,
.prevLinkClass,
.nextLinkClass {
  font-weight: bold;
  font-size: 12px;
  color: rgba(63, 71, 87, 0.6);
  padding: 4px 9px;
  display: block;
  border: 2px solid transparent;
  border-radius: 3px;

  @media screen and (max-width: 620px) {
    padding: 4px 6px;
  }

  &:hover {
    color: rgba(63, 71, 87, 1);
  }
}

.activeClass .pageLinkClass {
  color: rgba(63, 71, 87, 1);
}
.disabledClass {
  opacity: 0.5;
  pointer-events: none;
}

.prevLinkClass,
.nextLinkClass {
  border-color: rgba(63, 71, 87, 0.6);

  &:hover {
    border-color: rgba(63, 71, 87, 1);
  }
}
.pageClass:hover .pageLinkClass {
  color: rgba(63, 71, 87, 1);
}
</style>
